import React from 'react';

class CustomErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.defaultErrorMessage = '';
    this.defaultLoadingMessage = '';
    this.state = {
      error: null,
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error: error,
    };
  }
  componentDidCatch(error, errorInfo) {
    var _a, _b;
    if (this.showErrorDetails()) {
      console.error(
        `An error occurred in component ${
          (_a = this.props.rendering) === null || _a === void 0 ? void 0 : _a.componentName
        } (${(_b = this.props.rendering) === null || _b === void 0 ? void 0 : _b.uid}): `
      );
    }
    console.error({
      error,
      errorInfo,
    });
  }
  isInDevMode() {
    return 'production' === 'development';
  }
  showErrorDetails() {
    var _a, _b;
    return (
      this.isInDevMode() ||
      ((_a = this.props.sitecoreContext) === null || _a === void 0 ? void 0 : _a.pageState) ===
        layout.LayoutServicePageState.Edit ||
      ((_b = this.props.sitecoreContext) === null || _b === void 0 ? void 0 : _b.pageState) ===
        layout.LayoutServicePageState.Preview
    );
  }
  render() {
    var _a;
    if (this.state.error) {
      if (this.props.errorComponent) {
        return React.createElement(this.props.errorComponent, {
          error: this.state.error,
        });
      } else {
        if (this.showErrorDetails()) {
          return React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              {
                className: 'sc-jss-placeholder-error',
              },
              'A rendering error occurred in component',
              ' ',
              React.createElement(
                'em',
                null,
                (_a = this.props.rendering) === null || _a === void 0 ? void 0 : _a.componentName
              ),
              React.createElement('br', null),
              'Error: ',
              React.createElement(
                'em',
                null,
                this.state.error.message || JSON.stringify(this.state.error)
              )
            )
          );
        } else {
          return React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              {
                className: 'sc-jss-placeholder-error',
              },
              this.defaultErrorMessage
            )
          );
        }
      }
    }
    // do not apply suspense when suspense is disabled or when on already dynamic components
    if (this.props.disableSuspense || this.props.isDynamic) {
      return this.props.children;
    }
    return React.createElement(
      React.Suspense,
      {
        fallback: React.createElement(
          'h4',
          null,
          this.props.componentLoadingMessage || this.defaultLoadingMessage
        ),
      },
      this.props.children
    );
  }
}

export default CustomErrorBoundary;
